import React from 'react';
import { PictureAsPdf, Image as ImageIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { fechaSegura } from '../../utils/formatos';

/**
 * ============================================================================
 * CUADRICULA PRUEBAS - COMPONENTE FRONTEND (TAILWIND EDITION)
 * ============================================================================
 * Renderiza de forma visual en una rejilla los documentos del expediente
 * clínico del paciente (PDFs, Imágenes de analíticas, etc.).
 */
const CuadriculaPruebas = ({ expediente, baseUrl, onPreview, onDelete, loading }) => {

    // ========================================================================
    // 1. ESTADO DE CARGA (SKELETON FANTASMA NATIVO)
    // ========================================================================
    if (loading) {
        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {[1, 2, 3].map((item) => (
                    <div key={item} className="p-6 bg-white border border-slate-200 rounded-3xl flex flex-col items-center gap-4 animate-pulse">
                        <div className="w-14 h-14 bg-slate-200 rounded-full"></div>
                        <div className="w-full flex flex-col items-center gap-2">
                            <div className="w-4/5 h-5 bg-slate-200 rounded-md"></div>
                            <div className="w-2/5 h-3 bg-slate-200 rounded-md"></div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    // ========================================================================
    // 2. CONTROL DE EXPEDIENTE VACÍO
    // ========================================================================
    if (!expediente || expediente.length === 0) {
        return (
            <div className="flex justify-center items-center h-36 w-full">
                <p className="text-slate-500 italic font-semibold text-sm">
                    No hay documentos analíticos o pruebas cargadas en este expediente.
                </p>
            </div>
        );
    }

    // ========================================================================
    // 3. RENDERIZADO DE CUADRÍCULA ACTIVA (TAILWIND PURA)
    // ========================================================================
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {expediente.map((file) => (
                <div
                    key={file.id}
                    className="relative group bg-white border border-slate-200 rounded-3xl hover:border-clinica-primary hover:shadow-xl transition-all duration-300"
                >
                    {/* Área interactiva para previsualizar el PDF o imagen */}
                    <div
                        onClick={() => onPreview(`${baseUrl}${file.url}`, file.mimetype)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onPreview(`${baseUrl}${file.url}`, file.mimetype); }}
                        role="button"
                        tabIndex={0}
                        className="p-6 flex flex-col items-center text-center gap-4 cursor-pointer"
                    >
                        {file.mimetype?.includes('pdf')
                            ? <PictureAsPdf sx={{ fontSize: 50 }} className="text-red-500" />
                            : <ImageIcon sx={{ fontSize: 50 }} className="text-sky-500" />
                        }
                        <div className="w-full overflow-hidden">
                            <h4 className="text-sm font-extrabold text-slate-900 truncate">
                                {file.nombreOriginal}
                            </h4>
                            <p className="text-xs font-semibold text-slate-500 mt-1 uppercase tracking-wider">
                                {fechaSegura(file.fechaSubida, 'dd MMM yyyy', '--')}
                            </p>
                        </div>
                    </div>

                    {/* Botón flotante para la eliminación segura del documento */}
                    <button
                        onClick={(e) => {
                            e.stopPropagation(); // Evita abrir el preview accidentalmente al hacer clic en borrar
                            onDelete(file.id);
                        }}
                        className="absolute top-3 right-3 p-2 text-slate-400 bg-slate-100 hover:bg-red-500 hover:text-white rounded-xl opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-all duration-200"
                        title="Eliminar documento"
                    >
                        <DeleteIcon fontSize="small" />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default CuadriculaPruebas;